const items = [
  { id: 'admin', name: 'ROLES.ADMIN' },
  { id: 'resp', name: 'ROLES.MANAGER' },
  { id: 'tech', name: 'ROLES.TECH' },
];

module.exports = {
  rolesItems: items
};